import React from 'react'
import Modal from 'LuxKit/Modal/Modal'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_DATE_TIME_FORMAT } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import HelpPane from 'components/Common/HelpPane'

const ModalContent = styled.div`
  padding-top: ${rem(16)};
`

interface Props {
  checkInDate?: string | moment.Moment;
  startDate?: moment.Moment
}

function OfferPropertyCancellationPolicyModal(props: Props) {
  const {
    checkInDate,
    startDate,
  } = props

  const intlDateFormatter = useIntlDateFormatter()

  return <Modal
    title="Free cancellation"
  >
    <ModalContent>
      {!checkInDate && <BodyText variant="medium" as="p">
        Things don’t always work out. Our 7-day ‘change of mind’ guarantee is there to help.{' '}
        Limited Time Lux Exclusive bookings (excluding flights) may be cancelled with a full refund{' '}
        provided that cancellation occurs strictly within 7 days from the date of purchase{' '}
        and provided that the cancellation is made no less than 14 days prior to the check-in date.{' '}
        Please note: flights and experiences are subject to the refund policies of the respective operator.
      </BodyText>}
      {checkInDate && startDate && <BodyText variant="medium" as="p">
        Standard bookings can be cancelled with a full refund provided the cancellation is made by {intlDateFormatter(startDate, INTL_DATE_TIME_FORMAT)} (local time of property).
      </BodyText>}
      <HelpPane />
    </ModalContent>
  </Modal>
}

export default OfferPropertyCancellationPolicyModal
